/**
 * @param {string} userEmail
 * @returns {*}
 */
export function createHomepage(userEmail) {
  return Promise.resolve({
    'ecommerce':{
      'email' : userEmail,
    },
    'event':"homepage"

  });
}
